import { StyleSheet } from 'react-native';

export const PREF = {
  green: '#2E7D32',
  greenDark: '#1B5E20',
  softGreen: '#A5D6A7',
  ring: 'rgba(46,125,50,0.10)',
  bg: '#FAFAFA',
  surface: '#FFFFFF',
  ink: '#1A1A1A',
  muted: '#6B7280',
  softInk: '#9AA39C',
  line: '#EFEFEF',
  warn: '#E65100',
  chip: '#F4F5F4',
  warnBg: '#FFF1E6',
} as const;

export const preferenceStyles = StyleSheet.create({
  card: {
    backgroundColor: PREF.surface,
    marginHorizontal: 16,
    marginBottom: 16,
    borderRadius: 20,
    padding: 22,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.04,
    shadowRadius: 3,
    elevation: 1,
  },
  cardOnboarding: {
    backgroundColor: '#F4F5F4',
    marginHorizontal: 0,
    marginBottom: 0,
    borderRadius: 16,
    padding: 18,
    shadowOpacity: 0,
    elevation: 0,
  },
  onboardingForm: {
    gap: 12,
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: '800',
    color: PREF.ink,
  },
  cardHint: {
    fontSize: 12.5,
    color: PREF.softInk,
    marginTop: 3,
    lineHeight: 18,
  },
  field: {
    marginTop: 20,
  },
  fieldFirst: {
    marginTop: 16,
  },
  fieldLabel: {
    fontSize: 13,
    fontWeight: '700',
    color: PREF.muted,
    marginBottom: 11,
  },
  fieldLabelOnboarding: {
    fontSize: 11,
    fontWeight: '700',
    color: '#9CA3AF',
    marginBottom: 10,
    letterSpacing: 0.6,
    textTransform: 'uppercase',
  },
  fieldLabelMuted: {
    fontWeight: '500',
    color: PREF.softInk,
  },
  chipRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
  },
  chip: {
    backgroundColor: PREF.chip,
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderRadius: 999,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 7,
  },
  chipOnboarding: {
    backgroundColor: '#ECECEC',
  },
  chipOn: {
    backgroundColor: PREF.green,
  },
  chipText: {
    fontSize: 13.5,
    fontWeight: '600',
    color: '#3A423C',
  },
  chipTextOn: {
    color: '#fff',
  },
  chipCheck: {
    fontSize: 12,
    fontWeight: '700',
    color: '#fff',
  },
  stepper: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 20,
  },
  stepperOnboarding: {
    alignSelf: 'flex-start',
    backgroundColor: '#ECECEC',
    borderRadius: 14,
    paddingHorizontal: 18,
    paddingVertical: 8,
    gap: 24,
  },
  stepBtn: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: PREF.chip,
    alignItems: 'center',
    justifyContent: 'center',
  },
  stepBtnText: {
    fontSize: 20,
    color: PREF.ink,
    fontWeight: '600',
    lineHeight: 22,
  },
  stepValue: {
    fontSize: 20,
    fontWeight: '800',
    minWidth: 24,
    textAlign: 'center',
    color: PREF.ink,
  },
  segment: {
    flexDirection: 'row',
    backgroundColor: PREF.chip,
    borderRadius: 13,
    padding: 4,
    gap: 4,
  },
  segmentBtn: {
    flex: 1,
    paddingVertical: 11,
    paddingHorizontal: 6,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  segmentBtnOn: {
    backgroundColor: PREF.green,
    shadowColor: PREF.greenDark,
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.35,
    shadowRadius: 8,
    elevation: 2,
  },
  segmentText: {
    fontSize: 13,
    fontWeight: '600',
    color: PREF.muted,
    textAlign: 'center',
  },
  segmentTextOn: {
    color: '#fff',
  },
  pillRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  pill: {
    backgroundColor: '#ECECEC',
    paddingHorizontal: 14,
    paddingVertical: 10,
    borderRadius: 999,
  },
  pillOn: {
    backgroundColor: PREF.green,
  },
  pillText: {
    fontSize: 13.5,
    fontWeight: '600',
    color: '#4B5563',
  },
  pillTextOn: {
    color: '#fff',
  },
  tagRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 9,
    marginBottom: 13,
  },
  tag: {
    backgroundColor: PREF.ring,
    paddingVertical: 8,
    paddingLeft: 13,
    paddingRight: 11,
    borderRadius: 999,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  tagWarn: {
    backgroundColor: PREF.warnBg,
  },
  tagText: {
    fontSize: 13,
    fontWeight: '600',
    color: PREF.greenDark,
  },
  tagTextWarn: {
    color: PREF.warn,
  },
  tagClose: {
    fontSize: 14,
    fontWeight: '700',
    opacity: 0.65,
    color: PREF.greenDark,
  },
  tagCloseWarn: {
    color: PREF.warn,
  },
  textInput: {
    backgroundColor: '#fff',
    borderWidth: 1.5,
    borderColor: PREF.line,
    borderRadius: 13,
    paddingHorizontal: 15,
    paddingVertical: 13,
    fontSize: 14,
    color: PREF.ink,
  },
  rowsCard: {
    backgroundColor: PREF.surface,
    marginHorizontal: 16,
    borderRadius: 20,
    overflow: 'hidden',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.04,
    shadowRadius: 3,
    elevation: 1,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    paddingVertical: 17,
    paddingHorizontal: 18,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: PREF.line,
  },
  rowFirst: {
    borderTopWidth: 0,
  },
  rowLabel: {
    flex: 1,
    fontSize: 15,
    fontWeight: '600',
    color: PREF.ink,
  },
  rowValue: {
    fontSize: 13.5,
    fontWeight: '600',
    color: PREF.greenDark,
    textAlign: 'right',
    maxWidth: '55%',
  },
  rowValueWarn: {
    color: PREF.warn,
  },
  rowChevron: {
    fontSize: 16,
    color: PREF.softInk,
  },
  expand: {
    paddingHorizontal: 18,
    paddingBottom: 20,
    backgroundColor: PREF.surface,
  },
  memo: {
    backgroundColor: PREF.chip,
    borderRadius: 12,
    paddingVertical: 11,
    paddingHorizontal: 13,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
    marginBottom: 11,
  },
  memoText: {
    flex: 1,
    fontSize: 13.5,
    color: '#3A423C',
    lineHeight: 20,
  },
});
